import React, { useState, useEffect } from 'react'
import axios from 'axios'
import DaumPostcode from 'react-daum-postcode'
import { URL, OUTER_URL } from '../../utils/Utils'

import { isEmpty, beforeComma } from 'utils/UtilsFunction'

import './SubsidyMain.scss'

/**
 * 23.12.19 차량구매신청 외부 url 사용으로 인하여 해당 파일 close
 * @file 보조금신청 Address 화면
 */
function Address({ setAddressShow, formValues, setFormValues }) {
    const [address, setAddress] = useState('') // 검색한 주소

    useEffect(() => {
        //팝업 이외 영역 스크롤 방지
        document.body.style.cssText = `
      position: fixed; 
      top: -${window.scrollY}px;
      overflow-y: scroll;
      width: 100%;`
        return () => {
            const scrollY = document.body.style.top
            document.body.style.cssText = ''
            window.scrollTo(0, parseInt(scrollY || '0', 10) * -1)
        }
    }, [])

    // 주소 검색 완료했을때 보여줄 화면
    const handleComplete = data => {
        /* let address

        let dong_ri //kakao에서 동리 관련된 숫자를 안줘서 필요함

        //데이터타입 R:도로명 J:지명
        if (data.userSelectedType === 'R') {
            let _buildingName = isEmpty(data.buildingName) ? '' : ' (' + data.buildingName + ')'
            address = data.roadAddress + _buildingName

            dong_ri = data.roadname + ' ' + beforeComma(data.roadAddressEnglish)
        } else if (data.userSelectedType === 'J') {
            address = data.jibunAddress

            dong_ri = data.bname + ' ' + beforeComma(data.jibunAddressEnglish)
        } */

        // 시,도
        let user_sido = data.sido
        // 구,군
        let user_gugun = data.sigungu
        // 동,리
        let user_dong //도로명,지번에 따라 구분필요
        // 우편번호
        let user_zipcode = data.zonecode

        let address

        let dong_ri //kakao에서 동리 관련된 숫자를 안줘서 필요함

        //데이터타입 R:도로명 J:지명
        if (data.userSelectedType === 'R') {
            let _buildingName = isEmpty(data.buildingName) ? '' : ' (' + data.buildingName + ')'
            address = data.roadAddress + _buildingName
            user_dong = isEmpty(data.bname1)
                ? data.roadname + ' ' + beforeComma(data.roadAddressEnglish)
                : data.bname1 + ' ' + data.roadname + ' ' + beforeComma(data.roadAddressEnglish)

            dong_ri =
                beforeComma(data.roadAddressEnglish) +
                ' (' +
                data.bname +
                (isEmpty(data.buildingName) ? '' : ', ' + data.buildingName) +
                ')'
        } else if (data.userSelectedType === 'J') {
            address = data.jibunAddress
            user_dong = isEmpty(data.bname1)
                ? data.bname + ' ' + beforeComma(data.jibunAddressEnglish)
                : data.bname1 + ' ' + data.bname + ' ' + beforeComma(data.jibunAddressEnglish)

            // dong_ri = data.bname + ' ' + utils.beforeComma(data.jibunAddressEnglish)
            dong_ri =
                beforeComma(data.jibunAddressEnglish) +
                ' (' +
                data.bname +
                (isEmpty(data.buildingName) ? '' : ', ' + data.buildingName) +
                ')'
        }

        //console.log("address : ", address, ", dong_ri : ", dong_ri)

        setAddressShow(false)
        setFormValues({
            ...formValues,
            zipcode: data?.zonecode,
            sido: data?.sido,
            gugun: data?.sigungu,
            dong: user_dong,
            address: address,
        })
    }

    return (
        <div className="subsidy-two-user-info-address-popup" onClick={() => setAddressShow(false)}>
            <DaumPostcode
                autoClose
                onComplete={handleComplete}
                /* {...props} */
                onClick={e => e.stopPropagation()}
            />
        </div>
    )
}

export default Address
